jQuery(document).ready(function($) {
	
	$.anchors = {
		topOffset : $('.m-content--anchors--full').outerHeight(true),
		adminBarHeight : $('#wpadminbar').outerHeight(true),

		init: function() {

			$(window).scroll(function() {
				if ($('.m-anchors').length == 1) {
					var scroll = $(window).scrollTop();
					var anchorsTop = $('.m-anchors').offset().top - $('.m-anchors').outerHeight(true);

					var topOffset = $.anchors.topOffset;
					if ($('.logged-in').length == 1) {
						topOffset += $.anchors.adminBarHeight;
					}

					$('.m-anchors a').each(function() {
						var region = $(this).attr('href');

						var regionTop = $(region).offset().top - parseInt($(region).css('margin-top')) - topOffset - 1;
						var regionHeight = $(region).outerHeight(true);

						if(region == '#event-overview') {
							regionHeight += $('#event-overview-text').parents('.l-page__container-slim').outerHeight(true);
						}

						if(scroll >= regionTop) {
							if(scroll > (regionTop + regionHeight)) {
								$('.m-anchors a[href="'+region+'"]').removeClass('current');
							} else {
								$('.m-anchors a.current').removeClass('current');
								$('.m-anchors a[href="'+region+'"]').addClass('current');
							}
						}

						if((scroll < anchorsTop) && ($('.m-anchors .m-anchors__link--special.current').length >= 1)) {
							$('.m-anchors .m-anchors__link--special').removeClass('current');
						}
					});
				}
			});


			$(document).on('click', '.m-anchors a', function(e) {
				e.preventDefault();

				$(this).addClass('current');
				
				var region = $($(this).attr('href'));

				var topOffset = $.anchors.topOffset;
				if ($('.logged-in').length == 1) {
					topOffset += $.anchors.adminBarHeight;
				}

				var body = $('html, body');
				var position = region.offset().top - parseInt($(region).css('margin-top')) - topOffset;

				body.stop().animate({scrollTop: position}, 400, 'swing');
			});


		},
	
	};

});
